import { render, staticRenderFns } from "./RBadge.vue?vue&type=template&id=8ec6d6de&scoped=true&"
import script from "./RBadge.vue?vue&type=script&lang=js&"
export * from "./RBadge.vue?vue&type=script&lang=js&"
import style0 from "./RBadge.vue?vue&type=style&index=0&id=8ec6d6de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec6d6de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
